var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"fingerprintForm",staticClass:"text-left",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"2"}},[_vm._v(" WIP ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }